import Logo from '@/components/elements/icons/logo';
import { SocialFacebook } from '@/components/elements/icons/social-facebook';
import { SocialYouTube } from '@/components/elements/icons/social-Instagram';
import { SocialTwitter } from '@/components/elements/icons/social-twitter';
import { SocialInstagram } from '@/components/elements/icons/social-youtube';
import { Box, Button, Flex, Link as Clink, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import React from 'react';

const FooterAlt = () => {
  const { t } = useTranslation(`common`);
  const { push } = useRouter();
  const social = (
    <Flex justify="flex-end" color="#707070">
      <Clink
        aria-label="instagram"
        me={[4, null, 7]}
        href="https://www.instagram.com/voltranapp/"
        target="_blank"
        rel="nofollow"
      >
        <SocialInstagram boxSize={[4, null, 6]} />
      </Clink>
      <Clink
        target="_blank"
        rel="nofollow"
        aria-label="facebook"
        me={[4, null, 7]}
        href="https://www.facebook.com/voltran.app.9"
      >
        <SocialFacebook boxSize={[4, null, 6]} />
      </Clink>
      <Clink
        target="_blank"
        rel="nofollow"
        aria-label="youtube"
        me={[4, null, 7]}
        href="https://www.youtube.com/channel/UCByTtFOtl1h05Hbk_bEu-7w"
      >
        <SocialYouTube boxSize={[4, null, 6]} />
      </Clink>
      <Clink
        aria-label="twitter"
        href="https://twitter.com/AppVoltran"
        target="_blank"
        rel="nofollow"
      >
        <SocialTwitter boxSize={[4, null, 6]} />
      </Clink>
    </Flex>
  );

  const button = (
    <Button
      variant="solid"
      bgColor="#707070"
      color="white"
      onClick={() => push(`/download`)}
      _hover={{ bgColor: `#8a8a8a` }}
    >
      {t(`footer.cta_button`)}
    </Button>
  );
  return (
    <footer
      style={{
        backgroundColor: `#f2f2f2`,
      }}
    >
      <Box ms={10} pt={8} display={[`none`, null, `block`, `none`]}>
        {button}
      </Box>
      <Flex
        pt={[8, null, 10, 24]}
        className="boxed-container"
        px={[8, null, 16]}
        pb="32"
        direction={[`column-reverse`, null, `row`]}
      >
        <Flex direction="column" flex={[2, null, 1, 2]}>
          <Flex
            justify={[`space-between`, null, null, `start`]}
            mb="24"
            mt={[20, null, 0]}
            align="center"
          >
            <Link href="/" passHref>
              <Clink aria-label="voltran" me={[null, null, null, 16]}>
                <Logo h={[6, null, 9]} w="auto" color="#707070" isGrayscale />
              </Clink>
            </Link>
            <Box display={[`block`, null, `none`, `block`]}>{social}</Box>
          </Flex>
          <Text mb="5">{t(`footer.copyright`)}</Text>
          <Link href="/privacy-policy" passHref>
            <Clink mb="5">{t(`footer.section_one.privacy_policy`)}</Clink>
          </Link>
          <Link href="/terms-of-service" passHref>
            <Clink mb="5">{t(`footer.section_one.terms_of_service`)}</Clink>
          </Link>
          <Link href="/cookie-policy" passHref>
            <Clink mb="5">{t(`footer.section_one.clarification`)}</Clink>
          </Link>
        </Flex>
        <Flex justify="space-between" flex={1}>
          <Flex minW={36} direction="column" w={[`50%`, null, `inherit`]}>
            <Text fontWeight="semibold" fontSize="lg" mb="10">
              {t(`footer.section_two.what_is_voltran`)}
            </Text>
            <Link href="/features" passHref>
              <Clink mb="5">{t(`footer.section_two.features`)}</Clink>
            </Link>
            <Link href="/features#how-it-works" passHref>
              <Clink mb="5">{t(`footer.section_two.how_does_it_work`)}</Clink>
            </Link>
            <Link href="/faq" passHref>
              <Clink>{t(`footer.section_two.faq`)}</Clink>
            </Link>
          </Flex>
          <Flex minW={36} direction="column" w={[`50%`, null, `inherit`]}>
            <Text fontWeight="semibold" fontSize="lg" mb="10">
              {t(`footer.section_three.about_us`)}
            </Text>
            <Link href="/about-us#our-aim" passHref>
              <Clink mb="5">{t(`footer.section_three.our_aim`)}</Clink>
            </Link>
            <Link href="/about-us#team" passHref>
              <Clink>{t(`footer.section_three.team`)}</Clink>
            </Link>
          </Flex>
        </Flex>
        <Box
          display={[`block`, null, `none`, `block`]}
          mb={[12, null, 0]}
          ms={[null, null, null, 10]}
        >
          {button}
        </Box>
      </Flex>
      <Box pb={20} display={[`none`, null, `block`, `none`]}>
        {social}
      </Box>
    </footer>
  );
};

export default FooterAlt;
